import {
  call, put, select, cancel, debounce, takeLatest, takeEvery,
} from 'redux-saga/effects';
import API from 'library/constants/api';
import request from 'library/helpers/request';
import { showErrorNotification } from 'store/shared/actions';
import { getProjectItemsFilters } from 'store/project-items/selectors';
import { FILTER_KEYS } from 'store/project-items/fixtures';
import * as constants from './constants';
import * as actions from './actions';
import { setProjectItemsFilters, getProjectItems as getProjectItemsAction } from './actions';

export function* getProjectItems() {
  try {
    const {
      [FILTER_KEYS.HAS_MORE]: hasMore,
      [FILTER_KEYS.PAGE]: page,
      [FILTER_KEYS.TYPE]: type,
      // [FILTER_KEYS.QUANTITY]: qty,
      ...query
    } = yield select(getProjectItemsFilters);
    const currentPage = hasMore ? page + 1 : 1;
    const params = {
      query: {
        ...query,
        [FILTER_KEYS.PAGE]: currentPage,
        [FILTER_KEYS.SORT_DIRECTION]: query[FILTER_KEYS.SORT_DIRECTION] === 'itemName' ? 'project' : query[FILTER_KEYS.SORT_DIRECTION],
      },
    };

    const { data } = yield call(request, API.PROJECTS, 'GET', params);

    yield put(actions.getProjectItemsSuccess({
      data,
      filters: {
        ...params.query,
        [FILTER_KEYS.HAS_MORE]: data.length > 0 && query[FILTER_KEYS.PER_PAGE] === data.length,
        [FILTER_KEYS.SORT_DIRECTION]: params.query[FILTER_KEYS.SORT_DIRECTION] === 'project' ? 'itemName' : query[FILTER_KEYS.SORT_DIRECTION],
        // [FILTER_KEYS.TYPE]: type,
        // [FILTER_KEYS.QUANTITY]: qty,
        // [FILTER_KEYS.TAGS]: filters[FILTER_KEYS.TAGS],
        // [FILTER_KEYS.ITEMS]: filters[FILTER_KEYS.ITEMS],
      },
    }));
  } catch (e) {
    yield put(actions.getProjectItemsError(e));
    yield put(showErrorNotification({ message: 'Failed to fetch data, please try later.' }));
  }
}

// eslint-disable-next-line import/prefer-default-export
export function* getProjectItemsWatcher() {
  yield takeEvery(constants.GET_PROJECT_ITEMS, getProjectItems);
}

// eslint-disable-next-line import/prefer-default-export
export function* getProjectItemsDebaunced(action) {
  const filters = yield select(getProjectItemsFilters);

  const isLatestFiltersVersion = JSON.stringify(filters) === JSON.stringify(action.payload.filtersSnapshot);

  if(isLatestFiltersVersion) {
    yield put(setProjectItemsFilters(action.payload.values));
    yield put(getProjectItemsAction());
  }

  yield cancel();
}

export function* getProjectItemsDebauncedWatcher() {
  yield debounce(2000, constants.GET_PROJECT_ITEMS_DELAYED, getProjectItemsDebaunced);
}
